import Utils from './utils';
import VideoEditorCueVM from './video-editor-cue-vm';
import MediaQuestionPresenter from './media-question-presenter-vm';

export default function(params, options) {
  var self = this;

  self.defaults = {
    lastNewCueId: -1, //negative ids are new/unsaved
    parentEl: '#js-media-' + params.id,
    videoWrapper: '#js-video-' + params.id
  };

  self.config = _.extend({}, self.defaults, options);

  /*---------------------------------------- KO Handlers ----------------------------------------------------*/

  self.mapping = {
    include: ['media_cues_attributes', 'cued_attributes'],
    media_cues: {
      create: function(options) {
        return options.data.isA(VideoEditorCueVM) ? options.data : new VideoEditorCueVM(options.data, self);
      }
    }
  };

  // Map all properties to 'self'
  ko.mapping.fromJS(params, self.mapping, self);

  self.visible = ko.observable(false);
  self.subtitlesVisible = ko.observable(false);

  self.disabled = ko.computed(function() {
    return self.type() === 'NativeMedia' && !self.is_transcoding_completed();
  });

  self.enabled = ko.computed(function() {
    return (self.type() === 'NativeMedia' || self.type() == 'HostedVideo') && !self.is_transcoding_error();
  });

  self.isNative = ko.computed(function() {
    return self.type() === 'NativeMedia' ? true : false;
  });

  self.show = function(media, event) {
    self.buildPlayer(media, event);
  };

  self.deleteSubtitles = function (media, subtitle) {
    //first delete from server
    Kadenze.UIUtil.confirmAction(
      Kadenze.I18n.t('session.media.confirm_delete_subtitles'),
      function () {
        //post it
        var request = new Kadenze.AjaxRequest({
          method: 'DELETE',
          url: Kadenze.Routes.subtitle_path(subtitle.id())
        });

        request.done(function (response) {
          //remove from view model
          media.subtitles.remove(subtitle);

          //remove from renderer
          media.renderer().removeTextTrack(subtitle.label());
        });

        request.fail(function (xhr, textStatus, errorThrown) {
          new Kadenze.Notice.error({ message: xhr.responseJSON.message });
        });
      }
    );
  };

  self.showAddSubtitlesPane = function (media, event) {
    var $button = $(event.target),
      $pane = $('#add-subs-' + media.id()),
      isClosed = $button.hasClass('closed'),
      class_remove = isClosed === true ? 'closed' : 'open',
      class_add = isClosed === true ? 'open' : 'closed';

    $button.removeClass(class_remove).addClass(class_add);

    if (isClosed) {
      $pane.show();
    } else {
      $pane.hide();
    }

    self.subtitlesVisible(!self.subtitlesVisible());
  };

  self.addMediaQuestion = function(media, event) {
    var baseCue = {
      cue_start_time: Math.round10(media.renderer().currentTime(), -3).toString(),
      cue_end_time: '-1.0',
      cued: null,
      type: 'MediaQuestion'
    };

      // The cue needs to have access to it's parent video editor (self, in this case)
    var cue = new VideoEditorCueVM(baseCue, self);
    cue.edit();
  };

  /*---------------------------------------- Player Methods ----------------------------------------------------*/

  self.buildPlayer = function (media, event) {
    var $row = $(self.config.parentEl),
      $videoWrapper = $(self.config.videoWrapper);

    if(!media.renderer) {

      if(media.type() === 'HostedVideo') {
        self.buildIframePlayer(media, $videoWrapper);
      } else if (self.enabled()) {
        self.buildHTML5Player(media, $videoWrapper);
      }

      self.delegateRowEvents($row);
    }

    Utils.toggleRowVisibility(event);
  };

  self.buildIframePlayer = function(media, $wrapper) {
    media.renderer = ko.observable(new Kadenze.IframeMediaPlayer($wrapper, media.media_src()));
    media.renderer().show();
  };

  self.updateIframePlayer = function(media) {
    media.renderer().hide(); // This destroys and disposes of VJS
    media.renderer().$iframe_wrapper.empty(); // remove previous player from DOM
    // Build a new player with the updated source, using the same video_wrapper
    media.renderer(new Kadenze.IframeMediaPlayer(media.renderer().$iframe_wrapper, media.media_src()));
    media.renderer().show();

    // Save it
    self.saveIframePlayerMedia(media);
  };

  self.saveIframePlayerMedia = function(media) {
    var request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.lecture_medium_path(media.id()),
      type: 'PATCH',
      data: {
        lecture_medium: {
          lecture_id: self.lecture_id(),
          media_src: media.media_src(),
          type: 'HostedVideo',
          media_type: 'vimeo/youtube'
        }
      },
      loadingIndicator: {
        container: media.renderer().$iframe_wrapper
      }
    });

    request.done(function() {
      new Kadenze.Notice.success({ message: 'Changes saved successfully' });
    });
  };

  self.buildHTML5Player = function(media, $wrapper) {
    var mediaUrls = {
      h264_360_url: media.h264_360_url ? media.h264_360_url() : '',
      h264_720_url: media.h264_720_url ? media.h264_720_url() : '',
    };

    var mediaSubtitles = ko.toJS(media.subtitles);

    media.renderer = ko.observable(
      new Kadenze.VideoPlayer(
        $wrapper,
        mediaUrls,
        'vjs-instructor-skin',
        mediaSubtitles
      )
    );

    media.renderer().show();

    media.questions_presenter = ko.observable(
      new MediaQuestionPresenter(media.renderer(), media.media_cues)
    );

    media.questions_presenter().present();

    self.initSubtitleDropzone(media, $(self.config.parentEl));
  };

  /*---------------------------------------- UI Methods ----------------------------------------------------*/

  self.delegateRowEvents = function($row) {
    $row.find('.js-collapse').on('shown.bs.collapse', self.setRowVisibleState);
    $row.find('.js-collapse').on('hidden.bs.collapse', self.setRowHiddenState);
  };

  self.setRowVisibleState = function() {
    var $this = $(this);
    $('#js-media-collapse').sortable('disable');
    $this.find('.embed-responsive').css('display', 'block');
    self.visible(true);
  };

  self.setRowHiddenState = function() {
    var $this = $(this),
      media = ko.dataFor(this);

    $('#js-media-collapse').sortable('enable');
    self.visible(false);

    // If we can, and media is playing, pause it when the row is collapsed / hidden
    if(media.type() === 'NativeMedia' || media.type() === 'HostedVideo') {
      media.renderer().pause();
    }
  };


  /*---------------------------------------- Subtitle Methods ----------------------------------------------------*/

  self.initSubtitleDropzone = function (media, $row) {
    var $dz = $('#subtitle-dz-' + media.id()),
      $srcLang = $('#subtitle-lang-' + media.id());

    var message = JST['templates/dropzone-generic']({
      title: 'Subtitles',
      maxFilesize: 2,
      acceptedFiles: '.vtt',
      dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
      dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
      browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
      dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
      maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
      fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
      optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
    });

    var $previewTemplate = $(Kadenze.I18n.tt(JST['templates/dropzone-session-media-preview']({status: 'uploading'})));
    $previewTemplate.hide(); //hack to hide preview (dropzone limitation)

    var opts = {
      url: Kadenze.Routes.subtitles_path(),
      previewsContainer: '#session-media-preview',
      previewTemplate: $previewTemplate[0].outerHTML,
      autoProcessQueue: true,
      paramName: 'subtitle[src_file]',
      acceptedFiles: '.vtt',
      maxFiles: 1,
      accept: function(file, done) {
        self.setSubtitleUpdateMethod(file, done, $srcLang.val(), media);
      }
    };

    var callbacks = {
      sending: function (file, xhr, formData) {
        self.subtitleSending(file, formData, $srcLang, media);
      },
      success: function (file, response) {
        self.updateClientWithSubtitle(response, media);
      },
      error: function (file, errorMessage) {
        if (errorMessage !== 'cancelled') {
          new Kadenze.Notice.error({parentObject: $dz, message: errorMessage});
        }
      },
      complete: function (file) {
        self.subtitleDZ.removeFile(file);
      }
    };

    self.subtitleDZ = new Kadenze.MediaDropZone($dz, $(message), opts, callbacks, false);
  };

  self.setSubtitleUpdateMethod = function(file, done, curLanguage, media) {
    var found = self.findSubtitle(media, curLanguage);

    self.subtitleDZ.options.method = 'POST';
    self.subtitleDZ.options.url = Kadenze.Routes.subtitles_path();

    if (found) {
      Kadenze.UIUtil.confirmAction(
        Kadenze.I18n.t('session.media.confirm_update_subtitles'),
        function()  {
          self.subtitleDZ.options.method = 'PUT';
          self.subtitleDZ.options.url = Kadenze.Routes.subtitle_path(found.id());
          done();
        },
        function() {
          done('cancelled');
        }
      );
    } else {
      done();
    }
  };

  self.subtitleSending = function(file, formData, $languageInput, media) {
    var curLanguage = $languageInput.val(),
      srcLabel = $languageInput.find('option:selected').text(),
      found = self.findSubtitle(media, curLanguage);

    formData.append('subtitle[srclang]', curLanguage);
    formData.append('subtitle[label]', srcLabel);
    formData.append('subtitle[subtitleable_id]', media.id());
    formData.append('subtitle[subtitleable_type]', 'NativeMedia');

    if (found) {
      formData.append('subtitle[id]', found.id());
    }
  };

  self.findSubtitle = function(media, curLanguage) {
    return _.find(media.subtitles(), function (subtitle) {
      return subtitle.srclang() === curLanguage;
    });
  };

  self.updateClientWithSubtitle = function (response, media) {
    var koNewSub = ko.mapping.fromJS(response.subtitle);

    //new or existing?
    var found = _.find(media.subtitles(), function (subtitle) {
      return subtitle.id() === koNewSub.id();
    });

    if (found) {
      media.subtitles.replace(found, koNewSub);
    } else {
      media.subtitles.push(koNewSub);

      var opts = {src: koNewSub.src_file.url()};
      if (koNewSub.srclang() == 'en')
        opts.default = 'default';

      media.renderer().addTextTrack('captions', koNewSub.label(), koNewSub.srclang(), opts);
    }
  };

  /*---------------------------------------- Media Question Methods ----------------------------------------------------*/

  self.goToCueTime = function(time) {
    self.renderer().currentTime(parseFloat(time));
  };

  self.addOrUpdateQue = function (cue) {
    if(!cue) return;

    var newCue = new VideoEditorCueVM(cue, self),
      curCue = self.findQue(cue);

    if(curCue) {
      self.media_cues.replace(curCue, newCue);
    } else {
      // New / unsaved cues must have a negative id
      newCue.id = ko.observable(self.config.lastNewCueId--);
      self.media_cues.mappedCreate(newCue);
    }
  };

  self.findQue = function(cue) {
    return _.find(self.media_cues(), function(mediaCue) {
      return mediaCue.id() === cue.id;
    });
  };

  self.deleteCue = function (cue) {
    Kadenze.UIUtil.confirmAction( Kadenze.I18n.t('session.media.confirm_remove_question'), function () { self.destroyCue(cue); });
  };

  self.destroyCue = function(cue) {
    if (cue.id && cue.id() >= 0) {
      self.media_cues.destroy(cue);
    } else {
      self.media_cues.remove(cue);
    }
  };

  // END non ko methods

  return self;

} // End Kadenze.CourseSessionMediaViewModel
